import api from './api';
import type {
    MilestoneListResponse,
    PaymentMilestone,
    MilestonePaymentSubmission
} from '../types';

class MilestoneService {
    /**
     * Get all milestones for a specific application
     * GET /admissions/my-applications/{application_id}/milestones
     */
    async getApplicationMilestones(applicationId: number): Promise<MilestoneListResponse> {
        const response = await api.get<MilestoneListResponse>(
            `/admissions/my-applications/${applicationId}/milestones`
        );
        return response.data;
    }

    /**
     * Submit payment for a specific milestone
     * POST /admissions/my-applications/{application_id}/milestones/{milestone_id}/submit-payment
     */
    async submitMilestonePayment(
        applicationId: number,
        milestoneId: number,
        data: MilestonePaymentSubmission
    ): Promise<PaymentMilestone> {
        const response = await api.post<PaymentMilestone>(
            `/admissions/my-applications/${applicationId}/milestones/${milestoneId}/submit-payment`,
            data
        );
        return response.data;
    }
}

export default new MilestoneService();
